import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";
import { createTransferRecommendationsHubToSpokeMatrix } from "../../utils/transfer_recommendations_hub_to_spoke_matrix";

export const TransferRecommendationsHubToSpokeContainer = () => {
  // Customer-specific date hierarchy configurations
  const dateHierarchyColumnFilter = {
    week: "week",
    month: "month",
    day: "day",
  };

  // Hardcoded measure options for the dropdown (10 spoke measures).
  // Spoke view has no purchase-order machinery — only transfers in and demand.
  const measureColumnFilter = (params: DatePivotParams) => {
    const dateHierarchy =
      params.dateHierarchy.charAt(0).toUpperCase() +
      params.dateHierarchy.slice(1) +
      "s";
    return {
      "Starting Inventory On Hand": "Starting Inventory On Hand",
      "Forecasted Sales": "Forecasted Sales",
      "transfer order arrivals": "Transfer Order Arrivals",
      "Ending Inventory On Hand": "Ending Inventory On Hand",
      "Unfulfilled Demand": "Unfulfilled Demand",
      "Transfer Order To Place": "Transfer Order To Place",
      [`Target ${dateHierarchy} of Supply`]: `Target ${dateHierarchy} of Supply`,
      [`Starting ${dateHierarchy} of Supply`]: `Starting ${dateHierarchy} of Supply`,
      [`Ending ${dateHierarchy} of Supply`]: `Ending ${dateHierarchy} of Supply`,
      "In Stock Rate": "In Stock Rate",
    };
  };

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test_spoke",
        transformId: "transfer_recommendations_hub_to_spoke",
        folder: "outputs",
        title: "Transfer Planning",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: [],
        measureColumnFilter,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.EnableChartView,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createTransferRecommendationsHubToSpokeMatrix,
        chunkedMatrixTransformId: "transfer_recommendations_matrix_hub_to_spoke",
        excludeDetailRows: true,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
